import z from 'zod';
import { CurationSnapDetailItemSchema } from './get-curation-snaps.dto';

export const GetMySnapsServiceRequestSchema = z
  .object({
    page: z.number().int().min(1),
    size: z.number().int().min(1).max(100),
  })
  .describe('GetMySnapsServiceRequestSchema');

export type GetMySnapsServiceRequest = z.infer<typeof GetMySnapsServiceRequestSchema>;

export const GetMySnapsServiceResponseSchema = z
  .object({
    list: z.array(CurationSnapDetailItemSchema),
    total: z.number(),
    pagination: z.object({
      currentPage: z.number(),
      pageSize: z.number(),
      hasNextPage: z.boolean(),
      nextPage: z.number().optional(),
    }),
  })
  .describe('GetMySnapsServiceResponseSchema');

export type GetMySnapsServiceResponse = z.infer<typeof GetMySnapsServiceResponseSchema>;
